
import Catalog from '~/components/Catalog'
import Registration from '~/components/Registration/index.vue'
import { isGroupSubDomain } from '~/helpers/user'

export default {
  name: 'CatalogPage',
  methods: { isGroupSubDomain },
  components: {
    Catalog,
    Registration,
  },
  layout: isGroupSubDomain() ? 'registration' : 'catalog',
  middleware({ route, store, redirect }) {
    if (store.getters['user/user'] && !store.getters['user/user'].permissions?.hasAccessToCatalog) {
      redirect(`/inventory/${store.getters['inventory/rootFolderId']}`)
    }
    localStorage.setItem(
      'pathBackResultsCatalog',
      JSON.stringify(route.fullPath)
    )
  },
}
